"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceStatus = void 0;
var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["NOT_PAID"] = "not_paid";
    InvoiceStatus["PAYMENT_DUE"] = "payment_due";
    InvoiceStatus["POSTED"] = "posted";
    InvoiceStatus["PAID"] = "paid";
    InvoiceStatus["VOIDED"] = "voided";
})(InvoiceStatus || (exports.InvoiceStatus = InvoiceStatus = {}));
//# sourceMappingURL=InvoiceStatus.js.map